import React, { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';

interface Props {
  url: string;
  name?: string;
}

const ForumLogoPreview: React.FC<Props> = ({ url, name }) => {
  const [failed, setFailed] = useState(false);
  const trimmed = url.trim();

  useEffect(() => {
    setFailed(false);
  }, [trimmed]);

  if (!trimmed) {
    return (
      <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
        Logo URL girildiğinde önizleme burada görünür.
      </p>
    );
  }

  if (failed) {
    return (
      <div className="mt-3 flex items-center gap-2 rounded-lg border border-dashed border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-950/30 px-3 py-4 text-sm text-red-700 dark:text-red-300">
        <ImageOff size={18} className="shrink-0" />
        Logo yüklenemedi — URL’yi kontrol edin.
      </div>
    );
  }

  return (
    <div className="mt-3 rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-900/50 p-3">
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">Logo önizlemesi</p>
      <div className="flex items-center justify-center min-h-[72px] max-w-full">
        <img
          src={trimmed}
          alt={name?.trim() ? `${name} logosu` : 'Forum logosu'}
          onError={() => setFailed(true)}
          className="max-h-20 max-w-[240px] w-auto object-contain"
        />
      </div>
    </div>
  );
};

export default ForumLogoPreview;
